<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 洗个毛品牌配色 - V1.0 BETA */
:root {
  --brand-yellow: #FFD600;
  --brand-yellow-light: #FFF9E6;
  --brand-yellow-dark: #FFC107;
  --sidebar-bg: #1A1A1A;
  --sidebar-active: #FFD700;
  --text-dark: #333333;
  --text-gray: #666666;
  --text-light: #999999;
  --bg-gray: #F5F7FA;
  --bg-card: #FFFFFF;
  --border-color: #E8E8E8;
  --money-red: #C41A1A;
  --success-green: #52C41A;
  --warning-orange: #FA8C16;
  --danger-red: #F5222D;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-smoothing: grayscale;
  color: var(--text-dark);
  margin: 0;
  padding: 0;
}
body { margin: 0; padding: 0; background: var(--bg-gray); }

/* ========== Element UI 品牌色覆盖 ========== */

/* 按钮 - 主色为黄色 */
.el-button--primary { 
  background-color: var(--brand-yellow) !important; 
  border-color: var(--brand-yellow) !important; 
  color: var(--text-dark) !important;
  font-weight: 500;
}
.el-button--primary:hover, .el-button--primary:focus { 
  background-color: var(--brand-yellow-dark) !important; 
  border-color: var(--brand-yellow-dark) !important; 
}
.el-button--warning { 
  background-color: var(--brand-yellow) !important; 
  border-color: var(--brand-yellow) !important; 
  color: var(--text-dark) !important; 
}
.el-button--warning:hover { 
  background-color: var(--brand-yellow-dark) !important; 
  border-color: var(--brand-yellow-dark) !important; 
}

/* 菜单 - 深色背景 + 黄色高亮 */
.el-menu {
  background-color: var(--sidebar-bg) !important;
  border-right: none !important;
}
.el-menu-item {
  color: #BDBDBD !important;
}
.el-menu-item:hover {
  background-color: rgba(255,255,255,0.05) !important;
  color: #FFFFFF !important;
}
.el-menu-item.is-active { 
  color: var(--sidebar-active) !important; 
  background-color: transparent !important;
}
.el-submenu__title {
  color: #BDBDBD !important;
}
.el-submenu__title:hover {
  background-color: rgba(255,255,255,0.05) !important;
  color: #FFFFFF !important;
}
.el-submenu .el-menu-item.is-active {
  color: var(--sidebar-active) !important;
}

/* 分页 - 黄色激活 */
.el-pagination.is-background .el-pager li:not(.disabled).active { 
  background-color: var(--brand-yellow) !important; 
  color: var(--text-dark) !important;
}

/* 标签 */
.el-tag--warning { 
  background-color: var(--brand-yellow) !important; 
  border-color: var(--brand-yellow) !important; 
  color: var(--text-dark) !important; 
}
.el-tag--success {
  background-color: #F6FFED !important;
  border-color: #B7EB8F !important;
  color: var(--success-green) !important;
}
.el-tag--danger {
  background-color: #FFF1F0 !important;
  border-color: #FFA39E !important;
  color: var(--danger-red) !important;
}
.el-tag--info {
  background-color: #F5F5F5 !important;
  border-color: #D9D9D9 !important;
  color: var(--text-gray) !important;
}

/* 链接 */
.el-link--primary { color: #1890FF !important; }

/* 表单控件 */
.el-checkbox__input.is-checked .el-checkbox__inner { 
  background-color: var(--brand-yellow) !important; 
  border-color: var(--brand-yellow) !important; 
}
.el-radio__input.is-checked .el-radio__inner { 
  background-color: var(--brand-yellow) !important; 
  border-color: var(--brand-yellow) !important; 
}
.el-switch.is-checked .el-switch__core { 
  background-color: var(--success-green) !important; 
  border-color: var(--success-green) !important; 
}
.el-input__inner:focus { 
  border-color: var(--brand-yellow) !important; 
}

/* Tabs - 黄色激活 */
.el-tabs__item.is-active { 
  color: var(--text-dark) !important; 
  font-weight: 600;
}
.el-tabs__active-bar { 
  background-color: var(--brand-yellow) !important; 
  height: 3px !important;
}

/* 表格 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
}
.el-table th { 
  background-color: #FAFBFC !important; 
  color: var(--text-gray) !important;
  font-weight: 500 !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped td { 
  background-color: #FAFBFC !important; 
}
.el-table td, .el-table th {
  padding: 16px 0 !important;
}
.el-table--border {
  border: 1px solid var(--border-color) !important;
  border-radius: 8px !important;
}

/* 输入框 */
.el-input__inner {
  border-radius: 4px !important;
}

/* 按钮圆角 - 全圆角 Pill shape */
.el-button {
  border-radius: 20px !important;
}
.el-button--small {
  border-radius: 16px !important;
}
.el-button--mini {
  border-radius: 14px !important;
}

/* 卡片 */
.el-card {
  border-radius: 8px !important;
  border-color: var(--border-color) !important;
}

/* 对话框 */
.el-dialog {
  border-radius: 8px !important;
}
.el-dialog__header {
  border-bottom: 1px solid var(--border-color);
  padding: 16px 20px !important;
}
.el-dialog__body {
  padding: 20px !important;
}
.el-dialog__footer {
  border-top: 1px solid var(--border-color);
  padding: 12px 20px !important;
}

/* 通用样式 */
.money { color: var(--money-red) !important; font-weight: 600; }
.money-green { color: var(--success-green) !important; font-weight: 600; }
.text-primary { color: var(--text-dark) !important; }
.text-gray { color: var(--text-gray) !important; }
.text-light { color: var(--text-light) !important; }

/* 页面容器 */
.page-container {
  padding: 8px;
  background: var(--bg-gray);
  min-height: calc(100vh - 56px);
}

/* 筛选栏 */
.filter-bar {
  background: white;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

/* 统计栏 */
.stats-bar {
  background: white;
  padding: 10px 16px;
  border-radius: 4px;
  margin-bottom: 8px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  font-size: 13px;
  color: var(--text-gray);
}
.stats-bar strong {
  font-weight: 600;
  color: var(--money-red);
}

/* 表格紧凑 */
.el-table {
  border-radius: 4px;
  overflow: hidden;
}
.el-table td, .el-table th {
  padding: 10px 0 !important;
}
.el-table .cell {
  padding: 0 10px;
  font-size: 13px;
}

/* 分页紧凑 */
.el-pagination {
  margin-top: 8px;
  padding: 8px 0;
}

/* 按钮紧凑 */
.el-button--small {
  padding: 7px 12px;
  font-size: 12px;
}

/* 输入框紧凑 */
.el-input--small .el-input__inner,
.el-select--small .el-input__inner {
  height: 28px;
  line-height: 28px;
  font-size: 12px;
}

/* 日期选择器紧凑 */
.el-date-editor--daterange.el-input__inner,
.el-date-editor--datetimerange.el-input__inner {
  height: 28px;
  min-height: 28px;
}
</style>
